const COOKIE_NAME = 'enquiry_popup_dismissed';
const COOKIE_DAYS = 14;
const DEFAULT_DELAY = 5000;

const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    )
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, days) => {
  const maxAge = days * 24 * 60 * 60;
  const expires = new Date(Date.now() + maxAge * 1000).toUTCString();

  document.cookie = [
    name + '=' + encodeURIComponent(value),
    'expires=' + expires,
    'max-age=' + maxAge,
    'path=/',
    'SameSite=Lax'
  ].join('; ');
};

const clearCookie = (name) => {
  document.cookie = name + '=; Max-Age=0; path=/; SameSite=Lax';
};

const enquiryPopup = () => {
  const popup = document.querySelector('.js-enquiry-popup');

  if (!popup) return;

  const params = new URLSearchParams(window.location.search);
  const forceShow = params.has('show_enquiry');

  // Allow ?show_enquiry to bypass a previous dismiss while testing
  if (forceShow) {
    clearCookie(COOKIE_NAME);
  } else if (getCookie(COOKIE_NAME)) {
    popup.remove();
    return;
  }

  const closeBtn = popup.querySelector('.js-enquiry-popup-close');
  const delay = forceShow
    ? 500
    : parseInt(popup.getAttribute('data-delay'), 10) || DEFAULT_DELAY;
  let lastFocus = null;
  let opened = false;

  const open = () => {
    if (opened || !document.body.contains(popup)) return;
    if (!forceShow && getCookie(COOKIE_NAME)) return;

    opened = true;
    lastFocus = document.activeElement;
    popup.hidden = false;
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('enquiry-popup-open');

    if (closeBtn) {
      closeBtn.focus();
    }
  };

  const close = (persist = true) => {
    popup.classList.remove('is-active');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('enquiry-popup-open');

    if (persist && !forceShow) {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  };

  if (closeBtn) {
    closeBtn.addEventListener('click', () => close(true));
  }

  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      close(true);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      close(true);
    }
  });

  document.addEventListener('wpcf7mailsent', (event) => {
    if (!popup.contains(event.target)) return;

    window.setTimeout(() => close(true), 1200);
  });

  window.setTimeout(open, delay);
};

export default enquiryPopup;
